var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content.image)?_c('section',{staticClass:"image-module"},[_c('figure',[_c('img',{attrs:{"src":_vm.content.image.data.full_url,"alt":""}}),_c('figcaption',[_vm._v(_vm._s(_vm.content.image_caption))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }